import Qr from "../../components/qr/Qr"

const QrPrint = () => {

return <Qr></Qr>

}
export default QrPrint